import { render, staticRenderFns } from "./OnboardingUseCasesStep.vue?vue&type=template&id=6f66a0c2&scoped=true&"
import script from "./OnboardingUseCasesStep.vue?vue&type=script&lang=js&"
export * from "./OnboardingUseCasesStep.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingUseCasesStep.vue?vue&type=style&index=0&id=6f66a0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f66a0c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
installComponents(component, {VCombobox})
